// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3zAAp","title":"AfterFrontImage_title__3ML9C"};